// extracted by mini-css-extract-plugin
export default {"container":"RefPrice_container__V1Zp9","empty":"RefPrice_empty__Z9jGn","tag":"RefPrice_tag__3XEGt"};